import { createMuiTheme } from '@material-ui/core'
import { common } from '@material-ui/core/colors'

export const createTheme = () => {

    const PRIMARY_COLOR: string = '#0091EA'
    const PRIMARY_COLOR_DARK: string = '#0277BD'

    const SECONDARY_COLOR: string = '#929EAA'
    const SECONDARY_COLOR_DARK: string = '#687785'

    const ERROR_COLOR: string = '#DD2C00'

    const CHECKBOX_COLOR: string = '#607D8B'

    return createMuiTheme({
        palette: {
            primary: {
                main: PRIMARY_COLOR,
                dark: PRIMARY_COLOR_DARK,
                contrastText: common.white,
            },
            secondary: {
                main: SECONDARY_COLOR,
                dark: SECONDARY_COLOR_DARK,
                contrastText: common.white,
            },
            error: {
                main: ERROR_COLOR,
            }
        },
        spacing: 4,
        overrides: {
            // В данный момент нет возможности модифицировать цвет рамки только в состоянии focused
            // (https://github.com/mui-org/material-ui/pull/13105)
            // т.к. MuiNotchedOutline - private
            // Поэтому до появления такой возможности, цвет рамки будет 'rgba(0, 0, 0, 0.54)' во всех состояниях
            MuiOutlinedInput: {
                notchedOutline: {
                    borderColor: 'rgba(0, 0, 0, 0.54)',
                }
            },
            MuiFormControl: {
                root: {
                    // На IE11 проблемы с дефолтным display: inline-flex
                    display: 'flex'
                }
            },
            MuiInput: {
                'root': {
                    '&$disabled': {
                        color: 'rgba(0, 0, 0, 0.87)'
                    }
                },
                underline: {
                    '&:before': {
                        borderBottom: `1px solid ${SECONDARY_COLOR}`
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottom: `2px solid ${PRIMARY_COLOR}`
                    },
                    '&:after': {
                        borderBottom: `2px solid ${PRIMARY_COLOR}`
                    },
                    '&$disabled:before': {
                        borderBottomStyle: 'dashed',
                    },
                }
            },
            MuiCheckbox: {
                colorSecondary: {
                    '&$checked': {
                        color: CHECKBOX_COLOR,
                    },
                },
            },
            MuiButton: {
                contained: {
                    'background-color': SECONDARY_COLOR,
                    'color': 'white',
                    '&:hover': {
                        'background-color': SECONDARY_COLOR_DARK
                    },
                },
                textSecondary: {
                    color: 'rgba(0, 0, 0, 0.54)'
                }
            },
            MuiSvgIcon: {
                colorSecondary: {
                    color: 'rgba(0, 0, 0, 0.54)'
                },
                colorPrimary: {
                    color: PRIMARY_COLOR
                },
            },
            MuiPaper: {
                rounded: {
                    borderRadius: '2px'
                }
            }
        },
        typography: {
            body1: {
                fontSize: '1rem'
            },
            body2: {
                fontSize: '1rem'
            },
            fontSize: 14,
            htmlFontSize: 16,
        }
    })
}
